import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import queryString from "query-string";
import { apiService } from "../redux/services/apiService";
import { Spin } from "antd";

const RoleBasedRoute = ({ children, type }) => {
  const location = useLocation();
  const queryParams = queryString.parse(location.search);

  const roles = {
    create_group: [
      "$SUPER_USER",
      "Makro_Super_User",
      "Makro_IT",
      "SYSTEM_MANAGER",
      "r0a06064f_ea65_4b82_",
      "ra75e33e7_ff5f_47a3_",
    ],
    assign_group: [
      "$SUPER_USER",
      "Makro_Super_User",
      "Makro_IT",
      "SYSTEM_MANAGER",
      "r0a06064f_ea65_4b82_",
      "ra75e33e7_ff5f_47a3_",
    ],
    upload_orders: [
      "$SUPER_USER",
      "Makro_Super_User",
      "Makro_IT",
      "SYSTEM_MANAGER",
      "MakroStoreSupervisor",
      "Makro_Store_Admin",
      "r0a06064f_ea65_4b82_",
      "ra75e33e7_ff5f_47a3_",
    ],
    rider_billing_report: [
      "$SUPER_USER",
      "Makro_Super_User",
      "SYSTEM_MANAGER",
      "r0a06064f_ea65_4b82_",
      "ra75e33e7_ff5f_47a3_",
    ],
    route_master: [
      "$SUPER_USER",
      "Makro_Super_User",
      "Makro_IT",
      "SYSTEM_MANAGER",
      "r0a06064f_ea65_4b82_",
      "ra75e33e7_ff5f_47a3_",
    ],
  };

  const [loading, setLoading] = useState(true);
  const [role, setRole] = useState(null);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const session = await apiService.getSession(queryParams);
        setRole(session?.data?.personnel?.roleId || null);
        setUserId(
          session?.data?.personnel?.clientId &&
            session?.data?.personnel?.personnelId
            ? `${session.data.personnel.clientId}/personnel/${session.data.personnel.personnelId}`
            : null
        );
      } catch (error) {
        setRole(null);
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, [queryParams]);

  if (loading) {
    return (
      <div style={spinnerStyle}>
        <Spin size="large" />
      </div>
    );
  }

  return (!userId ||
    !userId.includes("mara") ||
    !userId.includes("personnel")) &&
    !roles?.[type]?.includes(role) ? (
    <Navigate to="/unauthorized" state={{ from: location }} />
  ) : (
    <Outlet />
  );
};

const spinnerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};

export default RoleBasedRoute;
